// ImageComponent.js
import React, { useEffect, useState, useMemo } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { listImages, deleteImage } from "../services/api"
import { DataState } from "../context/DataProvider";
// Dummy functions – replace these with your actual API calls if available.
const dummyDelete = () => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), 1000);
  });
};

const dummyDownload = () => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), 1000);
  });
};

const ImageComponent = ({ tempImages, justUploadedImages, setJustUploadedImages }) => {

  // const [fetchedImages, setFetchedImages] = useState([]);
  const {
    currentTaskId: taskId,
    userGoogleId,
    currentTaskImages: fetchedImages, setCurrentTaskImages: setFetchedImages, conversations
  } = DataState();

  // const ImageIdsInConversation = useMemo(() => {
  //   return new Set(conversations
  //     .filter(message => message.role === "user" && Array.isArray(message.content))
  //     .flatMap(message =>
  //       message.content.filter(item => item && item.type === "image_url" && item.image_id)
  //         .map(item => item.image_id)
  //     ));
  // }, [conversations]);

 const fetchImages = async () => {
    if (!userGoogleId) return;

    try {
      const data = await listImages(userGoogleId, taskId);
      if (data.error) {
        console.error("Error fetching images:", data.error);
        return;
      }
      const formattedImages = data.map((img) => ({
        id: img.file_id,
        ...img,
        uploading: false,
      }));
      setFetchedImages(formattedImages);
    } catch (error) {
      console.error("Failed to fetch images:", error);
    } finally {
      if (justUploadedImages) {
        setJustUploadedImages(false);
      }
    }
  };

  useEffect(() => {
    if (!userGoogleId) return;

    if (justUploadedImages) {
      fetchImages();
      setJustUploadedImages(false);
    }

  }, [justUploadedImages]);

  // useEffect(() => {
  //   if (!userGoogleId) return;
  //   fetchImages();
  // }, [taskId, userGoogleId]);



  // Combine temporary (uploading) images with the fetched final images.
  const allImages = [...fetchedImages, ...tempImages];

  // Handle deletion: mark as deleting, then call the backend endpoint.
  const handleDelete = async (id) => {
    // Mark image as deleting in the fetched images state.
    setFetchedImages((prevImages) =>
      prevImages.map((img) =>
        img.id === id ? { ...img, deleting: true } : img
      )
    );
    try {
      // Call the actual backend delete API.
      await deleteImage(id, userGoogleId);
      // Remove the image with the given id.
      setFetchedImages((prevImages) => prevImages.filter((img) => img.id !== id));
    } catch (error) {
      console.error("Error deleting file", error);
      // Optionally, reset the deleting flag if the deletion fails.
      setFetchedImages((prevImages) =>
        prevImages.map((img) =>
          img.id === id ? { ...img, deleting: false } : img
        )
      );
    } finally {
      setJustUploadedImages(true);
    }
  };

  // Handle download: mark as downloading, then open the URL.
  const handleDownload = (id) => {
    const image = allImages.find((img) => img.id === id);
    if (!image) return;
    // Here we update the fetchedImages state for downloaded images;
    // you can adjust if you need to update tempImages as well.
    setFetchedImages((prevImages) =>
      prevImages.map((img) =>
        img.id === id ? { ...img, downloading: true } : img
      )
    );
    dummyDownload().then(() => {
      window.open(image.url, '_blank');
      setFetchedImages((prevImages) =>
        prevImages.map((img) =>
          img.id === id ? { ...img, downloading: false } : img
        )
      );
    });
  };
  if (allImages.length == 0) return null;

  return (
    <div className="font-sans">
      {/* Custom CSS for animations and scrollbar styling */}
      <style>{`
        /* Upload scanning animation: moves from bottom to top */
        @keyframes scan {
          0% { transform: translateY(100%); }
          50% { transform: translateY(0%); }
          100% { transform: translateY(-100%); }
        }
        .animate-scan {
          animation: scan 1s linear infinite;
        }
        /* Delete scanning animation: moves from top to bottom */
        @keyframes deleteScan {
          0% { transform: translateY(-100%); }
          50% { transform: translateY(0%); }
          100% { transform: translateY(100%); }
        }
        .animate-delete-scan {
          animation: deleteScan 1s linear infinite;
        }
        /* WebKit scrollbar styling */
        .image-scroll-container::-webkit-scrollbar {
          height: 6px;
        }
        .image-scroll-container::-webkit-scrollbar-track {
          background: transparent;
        }
        .image-scroll-container::-webkit-scrollbar-thumb {
          background-color: rgba(62, 62, 62, 0.3);
          border-radius: 3px;
        }
        /* Firefox scrollbar styling */
        .image-scroll-container {
          scrollbar-width: thin;
          scrollbar-color: rgba(58, 58, 58, 0.3) transparent;
        }
      `}</style>

      {/* Horizontally scrollable images container */}
      <div className="image-scroll-container overflow-x-auto overflow-y-hidden whitespace-nowrap pt-3 pr-2 pl-2">
        {allImages.map((image) => (
          <div
            key={image.id}
            className="group inline-block relative align-bottom mr-2.5 transition-all duration-300"
          >
            <img
              src={image.url}
              alt="Pasted"
              className="block max-w-[150px] max-h-[150px]"
            />

            {/* Upload scanning overlay */}
            {image.uploading && (
              <div className="absolute inset-0 bg-white bg-opacity-40 pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-t from-transparent via-white/50 to-transparent animate-scan" />
              </div>
            )}

            {/* Deletion scanning overlay */}
            {image.deleting && (
              <div className="absolute inset-0 bg-red-500 bg-opacity-40 pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-red-200/50 to-transparent animate-delete-scan" />
              </div>
            )}

            {/* Download overlay: appears on hover when not uploading or deleting */}
            {(!image.uploading && !image.deleting) && (
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                <button
                  onClick={() => handleDownload(image.id)}
                  disabled={image.downloading}
                  className="bg-white rounded-full p-2 shadow-lg"
                >
                  {image.downloading ? (
                    // Animated icon while downloading.
                    <svg
                      className="w-6 h-6 text-[#5652CF] animate-spin"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                      />
                    </svg>
                  ) : (
                    // Standard download icon.
                    <svg
                      className="w-6 h-6 text-[#5652CF]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                      />
                    </svg>
                  )}
                </button>
              </div>
            )}

            {/* Delete button (always visible in top-right corner) */}
            <button
              onClick={() => handleDelete(image.id)}
              title="Remove Image"
              className="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 bg-white bg-opacity-80 rounded-full w-5 h-5 text-center leading-5 p-0 font-bold"
              disabled={image.deleting}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageComponent;
